import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
import classNames from 'classnames';
import { CLIENT_SETTINGS, COMPANY_NEW, CLIENT_EDIT, CLIENT_SHOW } from 'src/constants/EndpointUrls';
import Button from 'jbc-front/components/Button';
import CompanyDetail from './components/CompanyDetail';
import { Edit } from 'jbc-front/components/icons';
import { concatParamsToUrl, redirectTo } from 'src/utils/Http';
import { fetchCompany } from 'src/reducers/clients/clients';
import styles from './CompanyList.scss';
import { useTranslation } from 'react-i18next';

const CompanyList = props => {
  const { t } = useTranslation();
  const { client, companies, dispatch } = props;
  useEffect(() => {
    dispatch(fetchCompany());
  }, []);
  return (
    <div>
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">{t('features.Clients.CompanyList.office_list')}</h1>
      </div>
      <div className="l-wrap-l l-contents-wrap">
        <div className="u-mb20">
          <BreadCrumb>
            <BreadCrumb.Item label={t('features.Clients.CompanyList.setting')} path={CLIENT_SETTINGS} />
            <BreadCrumb.Item label={t('features.Clients.CompanyList.office_list')} />
          </BreadCrumb>
        </div>
        <div className={classNames('l-wrap-l', styles.registerBtn)}>
          <div className="u-mb20">
            <Button href={COMPANY_NEW} as="a" primary>
              {t('features.Clients.CompanyList.register_new_office')}
            </Button>
          </div>
        </div>
        <div className="l-overflow-scroll">
          <table className="m-table-list">
            <thead>
              <tr>
                <th>{t('features.Clients.CompanyList.corporate_number')}</th>
                <th>{t('features.Clients.CompanyList.office')}</th>
                <th>{t('features.Clients.CompanyList.phone_number')}</th>
                <th />
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{client.corporateNumber}</td>
                <td>{client.officeName}</td>
                <td>{client.telNumber}</td>
                <td>
                  <span className={styles.icon}>
                    <Edit onClick={() => redirectTo(CLIENT_SHOW)} size={18} />
                  </span>
                </td>
              </tr>
              {companies && companies.map(company => <CompanyDetail key={company.id} company={company} />)}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default connect()(CompanyList);